/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminNoticeDto } from '../../models/admin-notice-dto';

export interface AdminNoticeControllerFindAll$Params {
}

export function adminNoticeControllerFindAll(http: HttpClient, rootUrl: string, params?: AdminNoticeControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdminNoticeDto>>> {
  const rb = new RequestBuilder(rootUrl, adminNoticeControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AdminNoticeDto>>;
    })
  );
}

adminNoticeControllerFindAll.PATH = '/api/admin-notice';
